<template>

<div class="_page">
  <DemoBody>
    <DemoBodyResult
      :resultTitle="'Face Tags'"
      :resultCountTitle="'Mask'"
      :resultCountMin="result.head_tags.filter((m)=>m.mask).length"
      :resultCountMax="result.head_tags.length"
      v-on:reset="$emit('reset')"
      v-on:setSampleImage="$emit('setSampleImage', $event)"
      :imageUrl="imageUrl"
      :sampleImages="sampleImages"
    >
      <template v-slot:resultBody>
        <ImagesGrid
          :imageDimensions="imageDimensions"
          :baseImageUrl="imageUrl" 
          :images="result.head_tags"
          :detailed="true"
          :showFailOnNonSuccess="false"
          :detailKeys="[
            'Name',
            'age',
            'gender'
          ]"
          label="Mask"
          successTag="mask"
        />
      </template>
      <template v-slot:imageOverlay>
        <TargetBoxes :imageDimensions="imageDimensions" :baseImageUrl="imageUrl" :list="validList" successKey="mask" />
      </template>
    </DemoBodyResult>
  </DemoBody>
</div>

</template>

<script>
import DemoResultView from '../DemoResultView'
import ImagesGrid from '@/components/images/ImagesGrid'
import TargetBoxes from '@/components/targetBox/TargetBoxes'

export default {
  props: {
    result: Object
  },
  computed: {
    validList() {
      return this.result.head_tags
        .map(({location, mask})=> {
          return {
            location, mask
          }
        })
        // // .filter(({mask})=> mask)
    }
  },
  extends: DemoResultView,
  components: {
    ImagesGrid,
    TargetBoxes
  }
}
</script>